export default __webpack_public_path__ + "static/media/4.f6e1d5e8.jpg";